// gatsby-browser.js

import React from "react";
import { LeavingSiteModalProvider } from "./src/context/LeavingSiteModalContext";
import LeavingSiteModal from "./src/components/LeavingSiteModal";

// Import Bootstrap’s CSS (if not already imported in your layout)
import "./src/styles/global.scss";

/**
 * 1) Wrap the entire app with the modal provider
 */
export const wrapRootElement = ({ element }) => {
	return (
		<LeavingSiteModalProvider>
			{element}
			<LeavingSiteModal />
		</LeavingSiteModalProvider>
	);
};

/**
 * 2) Intercept external link clicks
 */
export const onRouteUpdate = () => {
	const currentOrigin = window.location.origin;
	const allLinks = document.querySelectorAll("a[href]");

	allLinks.forEach((link) => {
		// Skip if we've already added a listener
		if (link.dataset.externalListener) return;
		link.dataset.externalListener = "true";

		// Skip if link is mailto: or tel:
		if (link.href.startsWith("mailto:") || link.href.startsWith("tel:")) {
			return;
		}

		try {
			const linkOrigin = new URL(link.href).origin;
			const isExternal = linkOrigin !== currentOrigin;

			// If link is external, intercept the click
			if (isExternal) {
				link.addEventListener("click", (event) => {
					event.preventDefault();
					// Show the modal with the link
					if (window.___showLeavingSiteModal) {
						window.___showLeavingSiteModal(link.href);
					}
				});
			}
		} catch (e) {
			// If the URL constructor fails for some reason, do nothing
		}
	});
};
